import React from "react";
import { MotifBreadcrumb, MotifBreadcrumbItem } from "@ey-xd/motif-react";
import "./BreadcrumbHome.scss";
import { Link } from "react-router";

type BreadcrumbItem = {
  text: string;
  url?: string;
  icon?: JSX.Element;
  variant?: "default" | "alt";
  disabled?: boolean;
  blockNavigation?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  ariaLabel?: string;
};

const BreadcrumbHome: React.FC<BreadcrumbProps> = ({ items, ariaLabel }) => {
  return (
    <div
      style={{ display: "flex", alignItems: "center" }}
      className="breadcrumb-grid"
    >
      <MotifBreadcrumb aria-label={ariaLabel}>
        {items.map((item, index) => (
          <MotifBreadcrumbItem
            key={index}
            variant={item.variant || "default"}
            disabled={item.disabled}
          >
            {item.url ? (
              <Link
                onClick={(e) => {
                  if (item?.blockNavigation) {
                    e.preventDefault();
                  }
                }}
                to={item?.url ? item.url : ""}
                className="display-flex align-items-center breadcrumb-link"
              >
                {item.icon && index === 0 && items?.length < 3 && (
                  <span>{item.icon}</span>
                )}
                <span
                  className={`${
                    item.icon && index === 0 ? "pad-l-10" : "margin-left-0"
                  }`}
                >
                  {item.text}
                </span>
              </Link>
            ) : (
              <div className="display-flex align-items-center">
                {item.icon && <span>{item.icon}</span>}
                <span
                  className={`pad-l-10 ${item.icon ? "" : "margin-left-0"}`}
                >
                  {item.text}
                </span>
              </div>
            )}
          </MotifBreadcrumbItem>
        ))}
      </MotifBreadcrumb>
    </div>
  );
};

export default BreadcrumbHome;
